import ResultsPDF from './ResultsPDF';

export default ResultsPDF;
